var map = {
	"./author-1.webp": 90460,
	"./author-10.webp": 5194,
	"./author-2.webp": 37667,
	"./author-3.webp": 17999,
	"./author-4.webp": 27015,
	"./author-5.webp": 28157,
	"./author-6.webp": 23500,
	"./author-7.webp": 64321,
	"./author-8.webp": 79253,
	"./author-9.webp": 60056
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53045;